import user from "../../assets/svg/user-circle.svg";

export const Data = [
    {
      id: 1,
      image: user,
      title: "Yasin Abdullah",
      description:
        "A really good job, all aspects of the project were followed step by step and with good results.",
    },
    {
      id: 2,
      image: user,
      title: "Nasir Amin",
      description:
      "Professionalism and top-notch quality define this web programmer.He also pays great attention.",
    },
    {
      id: 3,
      image: user,
      title: "Ahmad Mubarok",
      description:
        "Responsive, friendly, and possessing an excellent work ethic. Undoubtedly the best choice for your web projects",
    },
  ];
